const deleteQuicksight = {
  toastr: 'Usuário deletado',
  toastr1: ' deletado com sucesso'
};

export default deleteQuicksight;
